import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import DateFilter from "../components/AllDishesDetail/DateFilter";
import AllCuisinesFilter from "../components/AllDishesDetail/AllCuisinesFilter";
import DietaryFilter from "../components/AllDishesDetail/DietaryFilter";
import Footer from "../components/Footer";
import {
  // handleGetAllChefs,
  handleGetAllDishesOfCity,
} from "../../services/get_without_auth";
import isValidURL from "../../ValidateUrl";
import { shefDetailPath } from "../../shefPath";

const ANDROID_PACKAGE = "com.anonymous.shefscloud_mobile";

// 1. Define the Skeleton Card Component
const SkeletonCard = () => {
  return (
    <div className="bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col border-2 border-gray-100 animate-pulse h-full">
      {/* Image Skeleton */}
      <div className="h-64 bg-gray-200 w-full relative">
        <div className="absolute top-4 right-4 bg-gray-300 rounded-full h-8 w-24"></div>
      </div>

      <div className="p-8 flex flex-col flex-grow">
        {/* Title Skeleton */}
        <div className="h-8 bg-gray-200 rounded w-3/4 mb-4"></div>

        {/* Chef Name Skeleton */}
        <div className="h-4 bg-gray-200 rounded w-1/2 mb-6"></div>

        {/* Rating Skeleton */}
        <div className="flex items-center space-x-2 mb-6">
          <div className="h-5 w-5 bg-gray-200 rounded-full"></div>
          <div className="h-5 bg-gray-200 rounded w-16"></div>
        </div>

        {/* Availability Skeleton */}
        <div className="mt-auto">
          <div className="h-4 bg-gray-200 rounded w-1/3 mb-3"></div>
          <div className="flex justify-between">
            {[1, 2, 3, 4, 5, 6, 7].map((i) => (
              <div key={i} className="w-10 h-10 rounded-full bg-gray-200"></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const DishDetail = () => {
  const [filterActiveTab, setFilterActiveTab] = useState(null);
  const [isFetching, setIsFetching] = useState(true); // Default to true for initial load
  const [dishes, setDishes] = useState([]);

  const filterTabClick = (tabNumber) => {
    setFilterActiveTab(tabNumber);
  };

  useEffect(() => {
    const city = JSON.parse(localStorage.getItem("region"));
    const currentUser = JSON.parse(localStorage.getItem("user"));

    const fetchAllDishes = async () => {
      try {
        setIsFetching(true);
        // Simulate a slight delay if API is too fast to see the skeleton (Optional, remove in production)
        // await new Promise(resolve => setTimeout(resolve, 1000)); 

        const dishResponse = await handleGetAllDishesOfCity(city?.id);
        
        let filteredDishes = dishResponse || [];
        if (currentUser && currentUser.id) {
          filteredDishes = filteredDishes.filter(dish => dish.user_id !== currentUser.id);
          console.log("Filtered out own dishes for chef:", currentUser.id);
        }
        setDishes(filteredDishes);
      } catch (error) {
        console.error("Error while fetching dishes \n", error);
      } finally {
        setIsFetching(false);
      }
    };

    if (city) {
        fetchAllDishes();
    } else {
        setIsFetching(false);
    }
  }, []);

  useEffect(() => {
    const isAndroid = /Android/i.test(navigator.userAgent);
    if (!isAndroid) return;

    const referrer = new URLSearchParams({
      destination: "all-dish-detail",
      source: "website",
    });

    const playStoreUrl =
      `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}` +
      `&referrer=${encodeURIComponent(referrer.toString())}`;

    window.location.replace(playStoreUrl);
  }, []);

  return (
    <>
      <Header />
      <div className="container mx-auto my-8 px-lg-2 px-4">
        <div>
          {filterActiveTab === 1 && (
            <div className="py-3 border-b">
              <DateFilter />
            </div>
          )}
          {filterActiveTab === 2 && (
            <div className="py-3 border-b">
              <AllCuisinesFilter />
            </div>
          )}
          {filterActiveTab === 3 && (
            <div className="py-3 border-b">
              <DietaryFilter />
            </div>
          )}
        </div>
        
        <div className="mt-8">
          <h2 className="text-secondary font-bold text-2xl mb-0 border-b pb-2">
            All Foods Plan
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-6">
            {isFetching ? (
              // 2. Render Skeletons while fetching
              Array(6).fill(0).map((_, index) => (
                <SkeletonCard key={index} />
              ))
            ) : dishes.length > 0 ? (
              // 3. Render Actual Dishes
              dishes.map((dish) => (
                <div
                  key={dish.id}
                  className="bg-white/90 backdrop-blur-md rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden flex flex-col group border-2 border-gray-100 hover:border-red-200 relative"
                >
                  {/* Enhanced Card Decorations */}
                  <div className="absolute top-6 right-6 w-5 h-5 bg-gradient-to-r from-red-500/40 to-red-600/30 rounded-full z-10 animate-pulse"></div>
                  <div className="absolute top-12 right-12 w-3 h-3 bg-red-400/50 rounded-full z-10 animate-pulse delay-300"></div>
                  <div className="absolute bottom-6 left-6 w-4 h-4 bg-red-300/40 rounded-full z-10 animate-pulse delay-700"></div>
                  <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-500 to-red-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={
                        dish.logo && isValidURL(dish.logo)
                          ? dish.logo
                          : "https://t4.ftcdn.net/jpg/04/70/29/97/360_F_470299797_UD0eoVMMSUbHCcNJCdv2t8B2g1GVqYgs.jpg"
                      }
                      alt={dish.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                      <Link 
                        to={`/dish-detail-single/${dish.id}`}
                        className="text-white bg-red-500/90 backdrop-blur-sm px-6 py-3 rounded-full flex items-center space-x-2 font-semibold shadow-lg transform -translate-y-4 group-hover:translate-y-0 transition-transform duration-300"
                      >
                        <svg 
                          xmlns="http://www.w3.org/2000/svg" 
                          width="20" 
                          height="20" 
                          viewBox="0 0 24 24" 
                          fill="none" 
                          stroke="currentColor" 
                          strokeWidth="2" 
                          strokeLinecap="round" 
                          strokeLinejoin="round"
                        >
                          <circle cx="9" cy="21" r="1"></circle>
                          <circle cx="20" cy="21" r="1"></circle>
                          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                        </svg>
                        <span className="text-white">Quick Add</span>
                      </Link>
                    </div>
                    <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm rounded-full px-4 py-2 shadow-lg">
                      <span className="text-red-600 font-bold text-lg">
                        {(
                          dish.chef_earning_fee +
                          dish.platform_price +
                          dish.delivery_price
                        ).toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </span>
                    </div>
                  </div>

                  <div className="p-8 flex flex-col flex-grow relative">
                    <div className="mb-4">
                      <h3 className="text-2xl font-bold text-gray-900 mb-2 truncate">
                        <Link to={`/dish-detail-single/${dish.id}`}>
                          {dish.name}
                        </Link>
                      </h3>

                      <p className="text-gray-500 font-medium">
                        by{" "}
                        <Link 
                          to={shefDetailPath(dish.user_id, dish?.user?.first_name, dish?.user?.last_name)}
                          className="text-red-600 font-semibold"
                        >
                          {`${dish?.user?.first_name || ""} ${dish?.user?.last_name || ""}`}
                        </Link>
                      </p>
                    </div>

                    <div className="flex items-center space-x-2 mb-6">
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="20" 
                        height="20" 
                        viewBox="0 0 24 24" 
                        fill="#f59e0b" 
                        stroke="#f59e0b" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                      </svg>
                      <span className="font-bold text-gray-700 text-lg">
                        {dish?.average_rating
                          ? parseFloat(dish.average_rating).toFixed(1)
                          : 0}
                      </span>
                      <span className="text-gray-500">
                        ({dish?.total_reviews || 0} reviews)
                      </span>
                    </div>

                    {/* Discount (if any) */}
                    {dish?.auto_applied_discounts?.length > 0 && (
                      <div className="mb-3 text-sm text-green-600 font-medium">
                        [
                        {dish.auto_applied_discounts[0].discount_type === "$"
                          ? dish.auto_applied_discounts[0].discount.toLocaleString("en-PK", {
                              style: "currency",
                              currency: "PKR",
                            })
                          : (
                              dish.chef_earning_fee *
                              (dish.auto_applied_discounts[0].discount / 100)
                            ).toLocaleString("en-PK", {
                              style: "currency",
                              currency: "PKR",
                            })}
                        <span className="text-xs ml-1">Off</span>]
                      </div>
                    )}

                    <div className="mt-auto">
                      <p className="text-sm font-bold text-gray-400 uppercase mb-3 tracking-wider">
                        Available this week
                      </p>
                      <div className="flex justify-between">
                        {[
                          { day: "S", key: "is_sunday" },
                          { day: "M", key: "is_monday" },
                          { day: "T", key: "is_tuesday" },
                          { day: "W", key: "is_wednesday" },
                          { day: "T", key: "is_thursday" },
                          { day: "F", key: "is_friday" },
                          { day: "S", key: "is_saturday" }
                        ].map(({day, key}, i) => (
                          <div
                            key={i}
                            className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-300 ${
                              dish[key] === 1 
                                ? "bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg scale-110" 
                                : "bg-gray-100 text-gray-400 hover:bg-gray-200"
                            }`}
                          >
                            {day}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              // 4. Empty State (Only shows if NOT fetching and NO dishes)
              <div className="col-span-full py-10 text-center">
                 <p className="font-semibold text-xl text-gray-500">
                  No dishes found in your area.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DishDetail;